import React from 'react';
import { Typography, Tooltip } from '@mui/material';
import { format } from 'date-fns';
import { he } from 'date-fns/locale';
import { Schema } from '../../../amplify/data/resource';

// @ts-ignore
type Employee = Schema['Employee']['type'];

interface SalaryMonthsDisplayProps {
  employees: Employee[];
}

const SalaryMonthsDisplay: React.FC<SalaryMonthsDisplayProps> = ({ employees }) => {
  if (!employees || employees.length === 0) {
    return (
      <Typography
        fontWeight={'700'}
        fontSize={'14px'}
        fontFamily={'AlmoniDL'}
      >
        {''}
      </Typography>
    );
  }

  const allFormattedMonthNames = employees
    .map(emp => emp.salaryMonth ? format(new Date(emp.salaryMonth), 'MMMM yyyy', { locale: he }) : null)
    .filter(name => name !== null);

  if (allFormattedMonthNames.length === 0) {
    return (
      <Typography
        fontWeight={'700'}
        fontSize={'14px'}
        fontFamily={'AlmoniDL'}
      >
        {''}
      </Typography>
    );
  }

  // Подсчитываем частоту каждого месяца
  const monthFrequency: { [key: string]: number } = {};
  allFormattedMonthNames.forEach(month => {
    if (month) {
      monthFrequency[month] = (monthFrequency[month] || 0) + 1;
    }
  });

  // Находим самый распространенный месяц
  let mostCommonMonth = '';
  let maxFrequency = 0;
  for (const [month, frequency] of Object.entries(monthFrequency)) {
    if (frequency > maxFrequency) {
      maxFrequency = frequency;
      mostCommonMonth = month;
    }
  }

  const uniqueMonthNames = Object.keys(monthFrequency);
  const tooltipTitleText = uniqueMonthNames.join(', ');
  const shouldShowTooltip = uniqueMonthNames.length > 1;

  const typographyElement = (
    <Typography
      fontWeight={'700'}
      fontSize={'14px'}
      fontFamily={'AlmoniDL'}
    >
      {mostCommonMonth}
    </Typography>
  );

  if (shouldShowTooltip) {
    return <Tooltip title={tooltipTitleText}>{typographyElement}</Tooltip>;
  }

  return typographyElement;
};

export default SalaryMonthsDisplay; 